import InfoIcon from '@mui/icons-material/Info';
import { Divider, Grid, IconButton, Tooltip } from '@mui/material';
import { WsButton, WsSelect, WsTypography, WsTypoVariants } from 'wisestep-base';

import { RelevanceSlider } from '../../../../components/WsCustomSlider';
import CardWrapper from '../../childRoutes/CardWrapper';
import { CampaignHeader, DuretionInput, SectionHeaders, TOGGLE_VARIANT } from '../../components';
import { candidateStatusOptions, relavanceSliderOptions } from '../../utils';

export interface EmailCampaignSettingCardProps {
  onSave: () => void;
  onReset: () => void;
}

const CandidateRulesCard = ({ onReset, onSave }: EmailCampaignSettingCardProps) => (
  <CardWrapper>
    <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
      Candidate Selection Rules
    </WsTypography>
    <Grid p={2} display="flex" direction="column" rowGap={1.5}>
      <SectionHeaders
        title={'Match Score Threshold'}
        subTitle={'Only include candidates with a minimum match score.'}
        titleVariant={WsTypoVariants.BODY1}
      />
      <Grid xs={4}>
        <RelevanceSlider title="" name="threshold" marks={relavanceSliderOptions} />
      </Grid>
      <Divider />
      <CampaignHeader name="recentCheck" skip={true}>
        <WsTypography variant={WsTypoVariants.BODY1} bold>
          Recent Activity filter
        </WsTypography>
      </CampaignHeader>
      <Grid display="flex" direction="row" alignItems="center">
        <DuretionInput
          tagLine="Only include candidates who are recently active in last"
          durationName="recentCampaign"
          timeSpanName="recentCampaignDuration"
        />
        <Tooltip title="Candidates who updated their profile or replied to recruiters.">
          <IconButton sx={{ p: 0, ml: -12 }}>
            <InfoIcon sx={{ height: 20, width: 20 }} />
          </IconButton>
        </Tooltip>
      </Grid>
      <Divider />
      <CampaignHeader name="nonResponsiveCandidateCheck" skip={true}>
        <WsTypography variant={WsTypoVariants.BODY1} bold>
          Exclude Non-Responsive Candidates
        </WsTypography>
      </CampaignHeader>
      <Grid display="flex" direction="row" columnGap={1.5} alignItems="center">
        <Grid>
          <WsTypography>{`Ignore candidates who didn't`}</WsTypography>
        </Grid>
        <Grid xs={2}>
          <WsSelect
            name="nonResponsiveCandidateStatus"
            selectArray={candidateStatusOptions}
            size="small"
          />
        </Grid>
        <Grid>
          <WsTypography>recent job emails for similar roles.</WsTypography>
        </Grid>
      </Grid>

      <Divider />
      <CampaignHeader name="excludeCandidateCheck" skip variant={TOGGLE_VARIANT.ENABLE}>
        <SectionHeaders
          title={'Exclude recently Applied'}
          subTitle={'Ignore candidates who already applied to this job or a similar role recently.'}
        />
      </CampaignHeader>

      <Grid display="flex" justifyContent="flex-end" columnGap={2}>
        <WsButton variant="outlined" onClick={onReset}>
          Discard
        </WsButton>
        <WsButton onClick={onSave}>Save</WsButton>
      </Grid>
    </Grid>
  </CardWrapper>
);

export default CandidateRulesCard;
